import React from 'react';
import Shortid from 'shortid';
import MenuItem from './MenuItem';

const MenuCategory = props => {
  const MenuItems = props.items.map(item => {
    return (
      <MenuItem
        dispatch={props.dispatch}
        activeItem={props.activeItem}
        label={item[0]}
        id={item[1]}
        key={Shortid.generate()}
      />
    );
  });

  return (
    <div className="ifdw-menu--category">
      <div className="ifdw-menu--headline">{props.title}</div>
      {MenuItems}
    </div>
  );
}

export default MenuCategory;



/** WEBPACK FOOTER **
 ** ./src/components/Menu/MenuCategory.js
 **/